export function breadth_first_search(grid, startNode, finishNode) {
    const visitedNodesInOrder = [];
    breadth_first_search_utils(grid, startNode, finishNode, visitedNodesInOrder);
    return visitedNodesInOrder;
}

function breadth_first_search_utils(grid, startNode, finishNode, visitedNodesInOrder) {
    // if (node.row === finishNode.row && node.col === finishNode.col) {
    //     return true;
    // }
    const queue = [];
    startNode.isVisited = true;
    queue.unshift(startNode); //add element at begining of the array

    while (queue.length > 0) {
        const node = queue.pop();
        const unvisitedNeighbors_array = getUnvisitedNeighbors(node, grid);
        for (const i in unvisitedNeighbors_array) {
            if (unvisitedNeighbors_array[i].isVisited || unvisitedNeighbors_array[i].isWall) {
                continue;
            } else {
                unvisitedNeighbors_array[i].previousNode = node;
                queue.unshift(unvisitedNeighbors_array[i]);
                visitedNodesInOrder.push(unvisitedNeighbors_array[i]);
                unvisitedNeighbors_array[i].isVisited = true;
                if (unvisitedNeighbors_array[i].row === finishNode.row && unvisitedNeighbors_array[i].col === finishNode.col) {
                    visitedNodesInOrder.pop();
                    return;
                }
            }
        }
    }
}

function getUnvisitedNeighbors(node, grid) {
    const neighbors = [];
    const { col, row } = node;
    if (row > 0) neighbors.push(grid[row - 1][col]);
    if (row < grid.length - 1) neighbors.push(grid[row + 1][col]);
    if (col > 0) neighbors.push(grid[row][col - 1]);
    if (col < grid[0].length - 1) neighbors.push(grid[row][col + 1]);
    return neighbors.filter(neighbor => !neighbor.isVisited);
}

export function getNodesInShortestPathOrder(finishNode) {
    const nodesInShortestPathOrder = [];
    let currentNode = finishNode;

    while (currentNode !== null) {
        nodesInShortestPathOrder.unshift(currentNode);
        currentNode = currentNode.previousNode;
    }
    return nodesInShortestPathOrder;
}
